<template>
    <div>

        <vue-headful :title="`${catalog.catalog_name} [Training Course Catalog] :: MeritEHS`"/>

        <h4 class="py-3 mb-4">
            <ol class="breadcrumb font-weight-bold m-0">
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/training-courses`">
                        <i class="fa fa-graduation-cap"></i> Training Courses
                    </router-link>
                </li>
                <li class="breadcrumb-item font-weight-light">
                    <router-link :to="`/training-courses/catalogs`">
                        Catalogs
                    </router-link>
                </li>
                <li class="breadcrumb-item active"><template v-if="!loading">{{ catalog.catalog_name }}</template></li>
            </ol>
        </h4>

        <div v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <div class="row">
                <div class="col-lg-5 col-md-8 col-12">
                    <div class="card">
                        <div class="card-header">
                            Catalog Details
                            <span class="pull-right">
                                <router-link :to="`/training-courses/catalogs/edit/${catalog.id}`" title="Edit Course Catalog" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                                <router-link :to="`/training-courses/catalogs/delete/${catalog.id}`" title="Delete Course Catalog" class="btn btn-sm btn-light">
                                    <span class="text-danger"><i class="fa fa-trash"></i> Delete</span>
                                </router-link>
                            </span>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Catalog Name:</div>
                                <div class="col-md-8">{{ catalog.catalog_name }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col-md-4 text-muted">Description:</div>
                                <div class="col-md-8">{{ catalog.catalog_description }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card mt-4">
                <div class="card-header">
                    Training Courses In this Catalog
                </div>
                <div class="card-body">
                    <training-course-list ref="trainingCourseIndexList" assetType="TrainingCatalog" :assetId="catalog.id"></training-course-list>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                id: this.$route.params.id,
                loading: true,
                saving: false,
                catalog: {},
            }
        },

        methods: {
            //Load the Account
            getCatalog(){
                //Send it
                this.$http.get('training-courses/catalogs/view/' + this.id)
                    .then(res => {
                        //Set data
                        this.catalog = res.data.catalog;
                    })
                    .catch(err => {

                    })
                    .then(() => {
                        //Reset
                        this.loading = false;
                    });
            },
        },

        mounted(){
            //Get it
            this.getCatalog();
        }
    }
</script>
